import axios from "axios";
import authHeader from '../../../authheader'

const EIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualEiApplication";



const getBoardRecommendations = (applicationId) => {
    return axios.get(`${EIAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { applicationId } });
}
const getBoardResponses = (applicationId) => {
    return axios.get(`${EIAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { applicationId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${EIAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${EIAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}